var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDiangleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15579 5L7.15579 0.5C7.15579 0.223858 6.93193 1.26441e-07 6.65579 0L2.15579 3.37172e-07C1.87965 1.68584e-07 1.65579 0.223858 1.65579 0.5C1.65579 0.776142 1.87965 1 2.15579 1L5.44868 1L0.64538 5.8033C0.64538 5.8033 0.291838 6.15678 0.645436 6.51041C0.999033 6.86403 1.35249 6.51041 1.35249 6.51041L6.15579 1.70711V5C6.15579 5.27614 6.37965 5.5 6.65579 5.5C6.93193 5.5 7.15579 5.27614 7.15579 5Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDiangleUp);
export default __webpack_public_path__ + "static/media/arrow-diangle-up.242ce8a09557342e4f89a08a074f323c.svg";
export { ForwardRef as ReactComponent };